import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import MyStableIcon from 'modules/Common/components/svg/MyStableIcon';

require("./MyStableButton.scss");

export default class MyStableButton extends PureComponent {

  static propTypes = {
    hasSubscriptions: PropTypes.bool,
    saveSubscriptions: PropTypes.func,
    deleteSubscriptions: PropTypes.func,
    noText: PropTypes.bool
  };

  render() {
    const {
      hasSubscriptions = false,
      saveSubscriptions = () => {},
      deleteSubscriptions = () => {},
      noText
    } = this.props;

    let className = "my-stable-button";
    let subText = "My Stable";

    if (hasSubscriptions) {
      className = `${className}-selected`;
      subText = "Following"
    }

    if (noText) {
      subText = null;
    }

    const handleClick = () => {
      if (hasSubscriptions) {
        deleteSubscriptions();
      }
      else {
        saveSubscriptions();
      }
    }

    return (
      <div {...{className}} id="my-stable-btn">
        <button onClick={handleClick}>
          <MyStableIcon title="My Stable" {...{subText}}/>
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/Subscriptions/MyStableButton.js